
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import { Controlador as Model, ControladorDeRespuestasPredefinidas, Buscador } from './respuestas-predefinidas-controlador';
    import { DataTableHeader } from 'vuetify';
    import editar from './respuestas-predefinidas-editar.vue';
    import { RespuestaPredefinida } from '@/__env/lib/Preguntas/RespuestaPredefinida';
    @Component( {
        name: "Componente",
        props: {},
        components: { editar }
    } )
    export default class Componente extends Vue
    {
        public get Controlador(): ControladorDeRespuestasPredefinidas { return Model; }
        public get Buscador(): Buscador { return Model.Buscador; }
        public Estado: 'cargando' | 'vacio' | 'ok' | 'error' = 'cargando';
        public Editando: boolean = false;

        @Prop()
        public Visible: boolean;
        @Watch( 'Visible' )
        async onVisible()
        {
            if ( this.Visible )
            {
                await this.Buscador.Buscar();
                this.iniciar();
            }
        }

        public Items: RespuestaPredefinida[] = [];
        public Headers: DataTableHeader[] = [
            { text: 'Titulo', value: 'Titulo' },
            { text: 'Respuesta', value: 'Respuesta' },
            { text: '', value: 'actions', sortable: false },
        ];
        iniciar()
        {
            this.Estado = 'cargando';
            if ( this.Buscador.Estado == 'cargando' )
            {

            } else
            {
                this.$nextTick( () =>
                {
                    this.Items = this.Buscador.Items;
                    this.Estado = this.Buscador.Estado;
                } );
            }
        }

        async mounted()
        {
            this.Buscador.$on( 'changed', () => this.iniciar() );
            await this.Buscador.Buscar();

        }

        async eliminar( item: RespuestaPredefinida )
        {
            if ( await this.$EventBus.Mensajes.SiNo( '¿Esta seguro de eliminar?' ) )
            {
                this.Controlador.eliminar( item );
            }


        }

        public IdEditando: number = 0;
        editar( item: RespuestaPredefinida )
        {
            this.IdEditando = item.Id;
            this.Editando = !this.Editando;
        }

        nueva()
        {
            this.IdEditando = 0;
            this.Editando = !this.Editando;
        }


    }
